<template>
  <div class="investor-content">
    <!-- 企业级战略机制链路：护城河 -->
    <section class="moat-section">
      <div class="container">
        <!-- 区域标签与标题 -->
        <div class="moat-section-header">
          <div class="header-label">{{ $t('investor.competitiveMoat.header') }}</div>
          <h2 class="moat-title">{{ $t('investor.competitiveMoat.moatTitle') }}</h2>
          <p class="moat-subtitle">{{ $t('investor.competitiveMoat.subtitle') }}</p>
        </div>

        <!-- 机制链路容器 -->
        <div class="moat-mechanism-container">
          <!-- 连接线 -->
          <svg class="moat-connection-lines" viewBox="0 0 1200 400" preserveAspectRatio="xMidYMid meet">
            <line class="connector-line" x1="300" y1="200" x2="500" y2="200" />
            <line class="connector-line" x1="700" y1="200" x2="900" y2="200" />
            
            <g class="arrow" transform="translate(480, 195)">
              <path d="M 0 0 L -8 -4 L -6 0 L -8 4 Z" fill="rgba(255,255,255,0.2)" />
            </g>
            <g class="arrow" transform="translate(880, 195)">
              <path d="M 0 0 L -8 -4 L -6 0 L -8 4 Z" fill="rgba(255,255,255,0.2)" />
            </g>
          </svg>

          <!-- 机制01：飞轮效应 -->
          <div class="mechanism-block mechanism-1">
            <div class="mechanism-number">01</div>
            <div class="mechanism-content">
              <h3 class="mechanism-title">{{ $t('investor.competitiveMoat.flywheel') }}</h3>
              <p class="mechanism-definition">{{ $t('investor.competitiveMoat.flywheelDef') }}</p>
              
              <ul class="mechanism-points">
                <li><span class="point-marker">•</span> {{ $t('investor.competitiveMoat.flywheelPoint1') }}</li>
                <li><span class="point-marker">•</span> {{ $t('investor.competitiveMoat.flywheelPoint2') }}</li>
                <li><span class="point-marker">•</span> {{ $t('investor.competitiveMoat.flywheelPoint3') }}</li>
              </ul>

              <div class="mechanism-result">
                <strong>{{ $t('investor.competitiveMoat.flywheelResult') }}</strong>
              </div>
            </div>
            <div class="mechanism-marker"></div>
          </div>

          <!-- 机制02：成瘾机制 -->
          <div class="mechanism-block mechanism-2">
            <div class="mechanism-number">02</div>
            <div class="mechanism-content">
              <h3 class="mechanism-title">{{ $t('investor.competitiveMoat.addiction') }}</h3>
              <p class="mechanism-definition">{{ $t('investor.competitiveMoat.addictionDef') }}</p>
              
              <ul class="mechanism-points">
                <li><span class="point-marker">•</span> {{ $t('investor.competitiveMoat.addictionPoint1') }}</li>
                <li><span class="point-marker">•</span> {{ $t('investor.competitiveMoat.addictionPoint2') }}</li>
                <li><span class="point-marker">•</span> {{ $t('investor.competitiveMoat.addictionPoint3') }}</li>
              </ul>

              <div class="mechanism-result">
                <strong>{{ $t('investor.competitiveMoat.addictionResult') }}</strong>
              </div>
            </div>
            <div class="mechanism-marker"></div>
          </div>

          <!-- 机制03：时间复利 -->
          <div class="mechanism-block mechanism-3">
            <div class="mechanism-number">03</div>
            <div class="mechanism-content">
              <h3 class="mechanism-title">{{ $t('investor.competitiveMoat.timeCompound') }}</h3>
              <p class="mechanism-definition">{{ $t('investor.competitiveMoat.timeCompoundDef') }}</p>
              
              <ul class="mechanism-points">
                <li><span class="point-marker">•</span> {{ $t('investor.competitiveMoat.timeCompoundPoint1') }}</li>
                <li><span class="point-marker">•</span> {{ $t('investor.competitiveMoat.timeCompoundPoint2') }}</li>
                <li><span class="point-marker">•</span> {{ $t('investor.competitiveMoat.timeCompoundPoint3') }}</li>
              </ul>

              <div class="mechanism-result">
                <strong>{{ $t('investor.competitiveMoat.timeCompoundResult') }}</strong>
              </div>
            </div>
            <div class="mechanism-marker"></div>
          </div>
        </div>

        <!-- 机制协同说明 -->
        <div class="moat-synergy">
          <div class="synergy-label">{{ $t('investor.competitiveMoat.synergyLabel') }}</div>
          <p class="synergy-text">{{ $t('investor.competitiveMoat.synergyText') }}</p>
          <p class="synergy-conclusion">{{ $t('investor.competitiveMoat.synergyConclusion') }}</p>
        </div>
      </div>
    </section>

    <!-- 投资价值展示 -->
    <section class="investment-hero">
      <div class="container">
        <div class="hero-content">
          <h1>{{ $t('investor.pageHeroTitle') }}</h1>
          <p class="hero-subtitle">{{ $t('investor.pageHeroSubtitle') }}</p>
          <div class="investment-highlights">
            <div class="highlight-item">
              <span class="highlight-number">{{ $t('investor.highlight1Num') }}</span>
              <span class="highlight-label">{{ $t('investor.highlight1Label') }}</span>
            </div>
            <div class="highlight-item">
              <span class="highlight-number">{{ $t('investor.highlight2Num') }}</span>
              <span class="highlight-label">{{ $t('investor.highlight2Label') }}</span>
            </div>
            <div class="highlight-item">
              <span class="highlight-number">{{ $t('investor.highlight3Num') }}</span>
              <span class="highlight-label">{{ $t('investor.highlight3Label') }}</span>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 市场机遇 -->
    <section class="market-opportunity">
      <div class="container">
        <div class="section-header">
          <h2>{{ $t('investor.marketTitle') }}</h2>
          <p>{{ $t('investor.marketDesc') }}</p>
        </div>
        
        <div class="opportunity-grid">
          <div class="opportunity-card">
            <div class="card-icon">
              <i class="fas fa-chart-line"></i>
            </div>
            <h3>{{ $t('investor.opp1Title') }}</h3>
            <p>{{ $t('investor.opp1Desc') }}</p>
            <ul>
              <li>{{ $t('investor.opp1Li1') }}</li>
              <li>{{ $t('investor.opp1Li2') }}</li>
              <li>{{ $t('investor.opp1Li3') }}</li>
            </ul>
          </div>
          
          <div class="opportunity-card">
            <div class="card-icon">
              <i class="fas fa-brain"></i>
            </div>
            <h3>{{ $t('investor.opp2Title') }}</h3>
            <p>{{ $t('investor.opp2Desc') }}</p>
            <ul>
              <li>{{ $t('investor.opp2Li1') }}</li>
              <li>{{ $t('investor.opp2Li2') }}</li>
              <li>{{ $t('investor.opp2Li3') }}</li>
            </ul>
          </div>
          
          <div class="opportunity-card">
            <div class="card-icon">
              <i class="fas fa-network-wired"></i>
            </div>
            <h3>{{ $t('investor.opp3Title') }}</h3>
            <p>{{ $t('investor.opp3Desc') }}</p>
            <ul>
              <li>{{ $t('investor.opp3Li1') }}</li>
              <li>{{ $t('investor.opp3Li2') }}</li>
              <li>{{ $t('investor.opp3Li3') }}</li>
            </ul>
          </div>
        </div>
      </div>
    </section>

    <!-- 商业模式 -->
    <section class="business-model">
      <div class="container">
        <div class="section-header">
          <h2>{{ $t('investor.bizTitle') }}</h2>
          <p>{{ $t('investor.bizDesc') }}</p>
        </div>
        
        <div class="revenue-streams">
          <div class="revenue-card">
            <h3>{{ $t('investor.rev1Title') }}</h3>
            <p>{{ $t('investor.rev1Desc') }}</p>
            <div class="revenue-details">
              <span class="revenue-label">{{ $t('investor.rev1Label') }}</span>
              <span class="revenue-amount">{{ $t('investor.rev1Amount') }}</span>
            </div>
          </div>
          
          <div class="revenue-card">
            <h3>{{ $t('investor.rev2Title') }}</h3>
            <p>{{ $t('investor.rev2Desc') }}</p>
            <div class="revenue-details">
              <span class="revenue-label">{{ $t('investor.rev2Label') }}</span>
              <span class="revenue-amount">{{ $t('investor.rev2Amount') }}</span>
            </div>
          </div>
          
          <div class="revenue-card">
            <h3>{{ $t('investor.rev3Title') }}</h3>
            <p>{{ $t('investor.rev3Desc') }}</p>
            <div class="revenue-details">
              <span class="revenue-label">{{ $t('investor.rev3Label') }}</span>
              <span class="revenue-amount">{{ $t('investor.rev3Amount') }}</span>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 融资计划 -->
    <section class="funding-plan">
      <div class="container">
        <div class="section-header">
          <h2>{{ $t('investor.fundingTitle') }}</h2>
          <p>{{ $t('investor.fundingSubtitle') }}</p>
        </div>
        
        <div class="funding-details">
          <div class="funding-item">
            <h3>{{ $t('investor.fundingUseTitle') }}</h3>
            <ul>
              <li>{{ $t('investor.fundingUseLi1') }}</li>
              <li>{{ $t('investor.fundingUseLi2') }}</li>
              <li>{{ $t('investor.fundingUseLi3') }}</li>
              <li>{{ $t('investor.fundingUseLi4') }}</li>
            </ul>
          </div>
          
          <div class="funding-item">
            <h3>{{ $t('investor.funding12Title') }}</h3>
            <ul>
              <li>{{ $t('investor.funding12Li1') }}</li>
              <li>{{ $t('investor.funding12Li2') }}</li>
              <li>{{ $t('investor.funding12Li3') }}</li>
              <li>{{ $t('investor.funding12Li4') }}</li>
            </ul>
          </div>
          
          <div class="funding-item">
            <h3>{{ $t('investor.fundingExpTitle') }}</h3>
            <ul>
              <li>{{ $t('investor.fundingExpLi1') }}</li>
              <li>{{ $t('investor.fundingExpLi2') }}</li>
              <li>{{ $t('investor.fundingExpLi3') }}</li>
              <li>{{ $t('investor.fundingExpLi4') }}</li>
            </ul>
          </div>
        </div>
      </div>
    </section>

    <!-- 团队介绍 -->
    <section class="team-section">
      <div class="container">
        <div class="section-header">
          <h2>{{ $t('investor.teamTitle') }}</h2>
          <p>{{ $t('investor.teamDesc') }}</p>
        </div>
        
        <div class="team-highlights">
          <div class="team-item">
            <i class="fas fa-users"></i>
            <h3>{{ $t('investor.team1Title') }}</h3>
            <p>{{ $t('investor.team1Desc') }}</p>
          </div>
          
          <div class="team-item">
            <i class="fas fa-code"></i>
            <h3>{{ $t('investor.team2Title') }}</h3>
            <p>{{ $t('investor.team2Desc') }}</p>
          </div>
          
          <div class="team-item">
            <i class="fas fa-heart"></i>
            <h3>{{ $t('investor.team3Title') }}</h3>
            <p>{{ $t('investor.team3Desc') }}</p>
          </div>
        </div>
      </div>
    </section>
    <!-- 里程碑与数据 -->
    <section class="milestones-section">
      <div class="container">
        <div class="section-header">
          <h2>{{ $t('investor.milestoneTitle') }}</h2>
          <p>{{ $t('investor.milestoneDesc') }}</p>
        </div>
        
        <div class="timeline">
          <div class="timeline-item">
            <div class="timeline-date">{{ $t('investor.m1Date') }}</div>
            <div class="timeline-content">
              <h3>{{ $t('investor.m1Title') }}</h3>
              <p>{{ $t('investor.m1Desc') }}</p>
              <div class="timeline-metrics">
                <span>{{ $t('investor.m1Met1') }}</span>
                <span>{{ $t('investor.m1Met2') }}</span>
              </div>
            </div>
          </div>
          
          <div class="timeline-item">
            <div class="timeline-date">{{ $t('investor.m2Date') }}</div>
            <div class="timeline-content">
              <h3>{{ $t('investor.m2Title') }}</h3>
              <p>{{ $t('investor.m2Desc') }}</p>
              <div class="timeline-metrics">
                <span>{{ $t('investor.m2Met1') }}</span>
                <span>{{ $t('investor.m2Met2') }}</span>
              </div>
            </div>
          </div>
          
          <div class="timeline-item">
            <div class="timeline-date">{{ $t('investor.m3Date') }}</div>
            <div class="timeline-content">
              <h3>{{ $t('investor.m3Title') }}</h3>
              <p>{{ $t('investor.m3Desc') }}</p>
              <div class="timeline-metrics">
                <span>{{ $t('investor.m3Met1') }}</span>
                <span>{{ $t('investor.m3Met2') }}</span>
              </div>
            </div>
          </div>
          
          <div class="timeline-item">
            <div class="timeline-date">{{ $t('investor.m4Date') }}</div>
            <div class="timeline-content">
              <h3>{{ $t('investor.m4Title') }}</h3>
              <p>{{ $t('investor.m4Desc') }}</p>
              <div class="timeline-metrics">
                <span>{{ $t('investor.m4Met1') }}</span>
                <span>{{ $t('investor.m4Met2') }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 竞争优势分析 -->
    <section class="competition-section">
      <div class="container">
        <div class="section-header">
          <h2>{{ $t('investor.compTitle') }}</h2>
          <p>{{ $t('investor.compDesc') }}</p>
        </div>
        
        <div class="comparison-table">
          <div class="comparison-row comparison-header">
            <div class="comparison-cell">{{ $t('investor.compDim') }}</div>
            <div class="comparison-cell">{{ $t('investor.compTrad1') }}</div>
            <div class="comparison-cell">{{ $t('investor.compTrad2') }}</div>
            <div class="comparison-cell comparison-us">{{ $t('investor.compUs') }}</div>
          </div>
          
          <div class="comparison-row">
            <div class="comparison-cell"><strong>{{ $t('investor.compRow1Dim') }}</strong></div>
            <div class="comparison-cell">{{ $t('investor.compRow1T1') }}</div>
            <div class="comparison-cell">{{ $t('investor.compRow1T2') }}</div>
            <div class="comparison-cell comparison-us">{{ $t('investor.compRow1Us') }}</div>
          </div>
          
          <div class="comparison-row">
            <div class="comparison-cell"><strong>{{ $t('investor.compRow2Dim') }}</strong></div>
            <div class="comparison-cell">{{ $t('investor.compRow2T1') }}</div>
            <div class="comparison-cell">{{ $t('investor.compRow2T2') }}</div>
            <div class="comparison-cell comparison-us">{{ $t('investor.compRow2Us') }}</div>
          </div>
          
          <div class="comparison-row">
            <div class="comparison-cell"><strong>{{ $t('investor.compRow3Dim') }}</strong></div>
            <div class="comparison-cell">{{ $t('investor.compRow3T1') }}</div>
            <div class="comparison-cell">{{ $t('investor.compRow3T2') }}</div>
            <div class="comparison-cell comparison-us">{{ $t('investor.compRow3Us') }}</div>
          </div>
          
          <div class="comparison-row">
            <div class="comparison-cell"><strong>{{ $t('investor.compRow4Dim') }}</strong></div>
            <div class="comparison-cell">{{ $t('investor.compRow4T1') }}</div>
            <div class="comparison-cell">{{ $t('investor.compRow4T2') }}</div>
            <div class="comparison-cell comparison-us">{{ $t('investor.compRow4Us') }}</div>
          </div>
          
          <div class="comparison-row">
            <div class="comparison-cell"><strong>{{ $t('investor.compRow5Dim') }}</strong></div>
            <div class="comparison-cell">{{ $t('investor.compRow5T1') }}</div>
            <div class="comparison-cell">{{ $t('investor.compRow5T2') }}</div>
            <div class="comparison-cell comparison-us">{{ $t('investor.compRow5Us') }}</div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'InvestorContent'
}
</script>

<style scoped>
.investor-content {
  color: white;
}

/* 护城河区域 - 企业级战略机制链路 */
.moat-section {
  padding: 120px 0 100px;
  background: #0B1220;
  position: relative;
  overflow: hidden;
}

.moat-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: 
    radial-gradient(circle at 20% 50%, rgba(0, 217, 255, 0.02) 0%, transparent 50%),
    radial-gradient(circle at 80% 50%, rgba(138, 43, 226, 0.02) 0%, transparent 50%);
  pointer-events: none;
}

/* 区域标签 */
.moat-section-header {
  text-align: center;
  margin-bottom: 80px;
  position: relative;
  z-index: 1;
}

.header-label {
  display: inline-block;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 2px;
  color: rgba(255, 255, 255, 0.5);
  margin-bottom: 1rem;
  font-weight: 600;
}

.moat-title {
  font-size: 2.8rem;
  font-weight: 700;
  color: white;
  margin-bottom: 0.8rem;
  letter-spacing: -0.5px;
}

.moat-subtitle {
  font-size: 1.1rem;
  color: rgba(255, 255, 255, 0.65);
  font-weight: 400;
  max-width: 600px;
  margin: 0 auto;
  letter-spacing: 0.3px;
}

/* 机制链路容器 */
.moat-mechanism-container {
  max-width: 1400px;
  margin: 0 auto 60px;
  position: relative;
  z-index: 1;
}

/* 连接线 */
.moat-connection-lines {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 400px;
  max-width: 1200px;
  margin: 0 auto;
  pointer-events: none;
}

.connector-line {
  stroke: rgba(255, 255, 255, 0.15);
  stroke-width: 1px;
  stroke-dasharray: none;
  transition: stroke 0.4s ease;
}

.moat-mechanism-container:hover .connector-line {
  stroke: rgba(255, 255, 255, 0.25);
}

/* 机制块布局 */
.moat-mechanism-container {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  align-items: start;
  padding: 0 1rem;
}

/* 单个机制块 */
.mechanism-block {
  background: #070B14;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  padding: 2.5rem;
  position: relative;
  transition: all 0.3s ease;
  padding-left: 3.5rem;
}

.mechanism-block::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 3px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.15) 0%, rgba(255, 255, 255, 0.05) 100%);
  border-radius: 12px 0 0 12px;
  transition: all 0.3s ease;
}

.mechanism-block:hover {
  border-color: rgba(255, 255, 255, 0.12);
  background: #0F1723;
}

.mechanism-block:hover::before {
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.25) 0%, rgba(255, 255, 255, 0.1) 100%);
  width: 4px;
}

/* 机制编号 */
.mechanism-number {
  position: absolute;
  left: 1rem;
  top: 1.5rem;
  font-size: 2.5rem;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.08);
  line-height: 1;
}

/* 机制内容 */
.mechanism-content {
  position: relative;
  z-index: 1;
}

.mechanism-title {
  font-size: 1.4rem;
  font-weight: 700;
  color: white;
  margin-bottom: 0.8rem;
  letter-spacing: -0.3px;
}

.mechanism-definition {
  font-size: 0.95rem;
  color: rgba(255, 255, 255, 0.75);
  font-weight: 500;
  margin-bottom: 1.5rem;
  line-height: 1.6;
  padding-bottom: 1.5rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

/* 机制作用点列表 */
.mechanism-points {
  list-style: none;
  padding: 0;
  margin-bottom: 1.8rem;
}

.mechanism-points li {
  display: flex;
  align-items: flex-start;
  gap: 0.8rem;
  padding: 0.6rem 0;
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.9rem;
  line-height: 1.5;
}

.point-marker {
  color: rgba(255, 255, 255, 0.3);
  font-weight: 600;
  flex-shrink: 0;
  margin-top: 0.2rem;
}

/* 壁垒输出 */
.mechanism-result {
  padding: 1rem;
  background: rgba(0, 217, 255, 0.05);
  border: 1px solid rgba(0, 217, 255, 0.1);
  border-radius: 8px;
  font-size: 0.85rem;
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.6;
}

.mechanism-result strong {
  color: rgba(255, 255, 255, 0.95);
  font-weight: 600;
}

/* 机制标记 */
.mechanism-marker {
  position: absolute;
  bottom: -20px;
  left: 50%;
  transform: translateX(-50%);
  width: 8px;
  height: 8px;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 50%;
  border: 1px solid rgba(255, 255, 255, 0.25);
}

/* 机制协同区域 */
.moat-synergy {
  max-width: 900px;
  margin: 80px auto 0;
  padding: 2.5rem;
  background: linear-gradient(135deg, rgba(0, 217, 255, 0.05) 0%, rgba(138, 43, 226, 0.05) 100%);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  text-align: center;
  position: relative;
  z-index: 1;
}

.synergy-label {
  display: inline-block;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 2px;
  color: rgba(255, 255, 255, 0.5);
  margin-bottom: 1rem;
  font-weight: 600;
}

.synergy-text {
  font-size: 1rem;
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.8;
  margin-bottom: 1rem;
  letter-spacing: 0.2px;
}

.synergy-conclusion {
  font-size: 1.1rem;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.9);
  letter-spacing: 0.3px;
}

/* 响应式 - 平板 */
@media (max-width: 1024px) {
  .moat-section {
    padding: 80px 0 70px;
  }

  .moat-title {
    font-size: 2.2rem;
  }

  .moat-mechanism-container {
    grid-template-columns: 1fr;
    gap: 2.5rem;
    margin-bottom: 50px;
  }

  .moat-connection-lines {
    display: none;
  }

  .mechanism-block {
    padding: 2rem;
    padding-left: 3rem;
  }

  .mechanism-number {
    font-size: 2rem;
    left: 0.8rem;
  }

  .moat-synergy {
    margin-top: 60px;
    padding: 2rem;
  }
}

/* 响应式 - 手机 */
@media (max-width: 640px) {
  .moat-section {
    padding: 60px 0 50px;
  }

  .moat-title {
    font-size: 1.8rem;
  }

  .moat-subtitle {
    font-size: 0.95rem;
  }

  .mechanism-block {
    padding: 1.5rem;
    padding-left: 2.5rem;
    border-radius: 10px;
  }

  .mechanism-number {
    font-size: 1.5rem;
    left: 0.6rem;
    top: 1rem;
  }

  .mechanism-title {
    font-size: 1.1rem;
    margin-bottom: 0.6rem;
  }

  .mechanism-definition {
    font-size: 0.85rem;
    margin-bottom: 1rem;
    padding-bottom: 1rem;
  }

  .mechanism-points li {
    font-size: 0.8rem;
    padding: 0.5rem 0;
    gap: 0.6rem;
  }

  .mechanism-result {
    font-size: 0.75rem;
    padding: 0.8rem;
  }

  .moat-synergy {
    margin-top: 40px;
    padding: 1.5rem;
  }

  .synergy-text {
    font-size: 0.9rem;
  }

  .synergy-conclusion {
    font-size: 1rem;
  }
}

.investment-hero {
  background: linear-gradient(135deg, #0A2463 0%, #1F41BB 50%, #0066FF 100%);
  padding: 120px 0 80px;
  text-align: center;
  position: relative;
  overflow: hidden;
}

.investment-hero::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="grid" width="10" height="10" patternUnits="userSpaceOnUse"><path d="M 10 0 L 0 0 0 10" fill="none" stroke="rgba(255,255,255,0.1)" stroke-width="0.5"/></pattern></defs><rect width="100" height="100" fill="url(%23grid)"/></svg>');
  opacity: 0.3;
}

.hero-content {
  position: relative;
  z-index: 1;
}

.hero-content h1 {
  font-size: 3.5rem;
  font-weight: 700;
  margin-bottom: 1rem;
  text-shadow: 0 2px 4px rgba(0,0,0,0.3);
}

.hero-subtitle {
  font-size: 1.3rem;
  opacity: 0.9;
  max-width: 800px;
  margin: 0 auto 3rem;
  line-height: 1.6;
}

.investment-highlights {
  display: flex;
  justify-content: center;
  gap: 3rem;
  flex-wrap: wrap;
}

.highlight-item {
  text-align: center;
}

.highlight-number {
  display: block;
  font-size: 2.5rem;
  font-weight: 700;
  color: #00B9AE;
  margin-bottom: 0.5rem;
}

.highlight-label {
  font-size: 1rem;
  opacity: 0.9;
}

.market-opportunity,
.business-model,
.funding-plan,
.team-section {
  padding: 80px 0;
  background: #070B14;
  position: relative;
  overflow: hidden;
}

.market-opportunity::before,
.business-model::before,
.funding-plan::before,
.team-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(circle at 50% 50%, rgba(0, 217, 255, 0.05) 0%, transparent 70%);
  pointer-events: none;
}

.section-header {
  text-align: center;
  margin-bottom: 60px;
  position: relative;
  z-index: 1;
}

.section-header h2 {
  font-size: 2.5rem;
  margin-bottom: 1rem;
}

.section-header p {
  font-size: 1.1rem;
  max-width: 600px;
  margin: 0 auto;
  opacity: 0.9;
}

.opportunity-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 2rem;
  max-width: 1200px;
  margin: 0 auto;
}

.opportunity-card {
  background: #0B1220;
  border-radius: 14px;
  padding: 2.5rem;
  border: 1px solid rgba(0, 217, 255, 0.1);
  transition: all 0.3s ease;
  position: relative;
  z-index: 1;
  border-left: 4px solid transparent;
}

.opportunity-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 4px;
  height: 100%;
  background: linear-gradient(180deg, #00D9FF, #0066FF);
  border-radius: 14px 0 0 14px;
}

.opportunity-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 24px rgba(0, 217, 255, 0.1);
  border-color: rgba(0, 217, 255, 0.3);
  background-color: #111B2E;
}

.card-icon {
  width: 44px;
  height: 44px;
  background: rgba(0, 217, 255, 0.08);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1.5rem;
}

.card-icon i {
  font-size: 1.3rem;
  color: #00D9FF;
}

.opportunity-card h3 {
  font-size: 1.3rem;
  margin-bottom: 1rem;
  color: white;
}

.opportunity-card p {
  font-size: 0.95rem;
  line-height: 1.6;
  margin-bottom: 1.5rem;
  color: rgba(255, 255, 255, 0.75);
}

.opportunity-card ul {
  list-style: none;
  padding: 0;
}

.opportunity-card li {
  padding: 0.6rem 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.85rem;
  line-height: 1.5;
}

.opportunity-card li:last-child {
  border-bottom: none;
}

.revenue-streams {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  max-width: 1000px;
  margin: 0 auto;
}

.revenue-card {
  background: #0B1220;
  border-radius: 14px;
  padding: 2rem;
  border: 1px solid rgba(0, 217, 255, 0.1);
  text-align: center;
  position: relative;
  z-index: 1;
  transition: all 0.3s ease;
  border-left: 4px solid transparent;
}

.revenue-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 4px;
  height: 100%;
  background: linear-gradient(180deg, #00D9FF, #0066FF);
  border-radius: 14px 0 0 14px;
}

.revenue-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 24px rgba(0, 217, 255, 0.1);
  border-color: rgba(0, 217, 255, 0.3);
  background-color: #111B2E;
}

.revenue-card h3 {
  font-size: 1.2rem;
  margin-bottom: 1rem;
  color: white;
}

.revenue-card p {
  font-size: 0.9rem;
  line-height: 1.6;
  margin-bottom: 1.5rem;
  color: rgba(255, 255, 255, 0.8);
}

.revenue-details {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  background: rgba(0, 217, 255, 0.08);
  border-radius: 8px;
  border: 1px solid rgba(0, 217, 255, 0.15);
}

.revenue-label {
  font-size: 0.8rem;
  color: rgba(255, 255, 255, 0.65);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-weight: 600;
}

.revenue-amount {
  font-size: 1.2rem;
  font-weight: 700;
  color: #00D9FF;
}

.funding-details {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  max-width: 1000px;
  margin: 0 auto;
}

.funding-item {
  background: #0B1220;
  border-radius: 14px;
  padding: 2rem;
  border: 1px solid rgba(0, 217, 255, 0.1);
  position: relative;
  z-index: 1;
  border-left: 4px solid transparent;
  transition: all 0.3s ease;
}

.funding-item::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 4px;
  height: 100%;
  background: linear-gradient(180deg, #00D9FF, #0066FF);
  border-radius: 14px 0 0 14px;
}

.funding-item:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 24px rgba(0, 217, 255, 0.1);
  border-color: rgba(0, 217, 255, 0.3);
  background-color: #111B2E;
}

.funding-item h3 {
  font-size: 1.2rem;
  margin-bottom: 1rem;
  color: white;
}

.funding-item ul {
  list-style: none;
  padding: 0;
}

.funding-item li {
  padding: 0.6rem 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.85rem;
  line-height: 1.5;
}

.funding-item li:last-child {
  border-bottom: none;
}

.team-highlights {
  display: flex;
  justify-content: center;
  align-items: stretch;
  gap: 1.5rem;
  max-width: 1000px;
  margin: 0 auto;
  flex-wrap: wrap;
}

.team-item {
  background: #0B1220;
  border-radius: 14px;
  padding: 2rem 1.5rem;
  text-align: center;
  border: 1px solid rgba(0, 217, 255, 0.1);
  position: relative;
  z-index: 1;
  flex: 1;
  min-width: 200px;
  max-width: 300px;
  transition: all 0.3s ease;
  border-top: 4px solid transparent;
}

.team-item::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #00D9FF, #0066FF);
  border-radius: 14px 14px 0 0;
}

.team-item i {
  font-size: 2.2rem;
  color: #00D9FF;
  margin-bottom: 1rem;
}

.team-item h3 {
  font-size: 1.2rem;
  margin-bottom: 1rem;
  color: white;
}

.team-item p {
  font-size: 0.9rem;
  line-height: 1.6;
  color: rgba(255, 255, 255, 0.8);
}

.team-item:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 24px rgba(0, 217, 255, 0.1);
  border-color: rgba(0, 217, 255, 0.3);
  background-color: #111B2E;
}

/* 里程碑section */
.milestones-section {
  padding: 80px 0;
  background: #070B14;
  position: relative;
  overflow: hidden;
}

.milestones-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(circle at 50% 50%, rgba(0, 217, 255, 0.05) 0%, transparent 70%);
  pointer-events: none;
}

.timeline {
  max-width: 900px;
  margin: 0 auto;
  position: relative;
  padding: 2rem 0;
}

.timeline::before {
  content: '';
  position: absolute;
  left: 50%;
  top: 0;
  bottom: 0;
  width: 2px;
  background: linear-gradient(180deg, transparent, rgba(0, 217, 255, 0.3), transparent);
  transform: translateX(-50%);
}

.timeline-item {
  display: flex;
  margin-bottom: 3rem;
  align-items: center;
  position: relative;
  z-index: 1;
}

.timeline-item:nth-child(even) {
  flex-direction: row-reverse;
}

.timeline-date {
  flex: 0 0 150px;
  text-align: center;
  font-weight: 700;
  color: #00D9FF;
  font-size: 1.1rem;
  padding: 1rem;
  position: relative;
}

.timeline-content {
  flex: 1;
  background: #0B1220;
  border-radius: 14px;
  padding: 2rem;
  border: 1px solid rgba(0, 217, 255, 0.1);
  margin: 0 2rem;
  transition: all 0.3s ease;
  position: relative;
}

.timeline-content::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 4px;
  height: 100%;
  background: linear-gradient(180deg, #00D9FF, #0066FF);
  border-radius: 14px 0 0 14px;
}

.timeline-content:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 24px rgba(0, 217, 255, 0.1);
  border-color: rgba(0, 217, 255, 0.3);
  background-color: #111B2E;
}

.timeline-item:nth-child(odd) .timeline-content {
  margin-left: 0;
}

.timeline-item:nth-child(even) .timeline-content {
  margin-right: 0;
}

.timeline-content h3 {
  color: white;
  font-size: 1.3rem;
  margin-bottom: 0.5rem;
}

.timeline-content p {
  color: rgba(255, 255, 255, 0.9);
  line-height: 1.6;
  margin-bottom: 1rem;
}

.timeline-metrics {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
}

.timeline-metrics span {
  padding: 0.5rem 1rem;
  background: rgba(0, 217, 255, 0.08);
  border-radius: 8px;
  border: 1px solid rgba(0, 217, 255, 0.15);
  color: rgba(255, 255, 255, 0.8);
  font-size: 0.8rem;
  font-weight: 600;
}

/* 竞争分析section */
.competition-section {
  padding: 80px 0;
  background: #070B14;
  position: relative;
  overflow: hidden;
}

.competition-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(circle at 50% 50%, rgba(0, 217, 255, 0.05) 0%, transparent 70%);
  pointer-events: none;
}

.comparison-table {
  max-width: 1200px;
  margin: 0 auto;
  background: #0B1220;
  border-radius: 14px;
  padding: 2rem;
  border: 1px solid rgba(0, 217, 255, 0.1);
  overflow-x: auto;
  position: relative;
  z-index: 1;
}

.comparison-row {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1.5fr;
  gap: 1rem;
  padding: 1rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.comparison-row:last-child {
  border-bottom: none;
}

.comparison-header {
  font-weight: 700;
  color: white;
  border-bottom: 2px solid rgba(0, 217, 255, 0.2) !important;
  background: rgba(0, 217, 255, 0.08);
  border-radius: 8px;
}

.comparison-cell {
  color: rgba(255, 255, 255, 0.9);
  padding: 0.5rem;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}

.comparison-us {
  background: rgba(0, 217, 255, 0.1);
  border-radius: 6px;
  font-weight: 600;
  color: #00D9FF !important;
  border: 1px solid rgba(0, 217, 255, 0.2);
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .opportunity-grid {
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 1.5rem;
  }
}

@media (max-width: 768px) {
  .moat-section {
    padding: 60px 0 50px;
  }
  
  .moat-title {
    font-size: 1.8rem;
  }
  
  .moat-subtitle {
    font-size: 0.95rem;
  }

  .hero-content h1 {
    font-size: 2.5rem;
  }
  
  .investment-highlights {
    gap: 2rem;
  }
  
  .highlight-number {
    font-size: 2rem;
  }
  
  .opportunity-grid,
  .revenue-streams,
  .funding-details {
    grid-template-columns: 1fr;
  }
  
  .team-highlights {
    flex-direction: column;
    align-items: center;
    gap: 1rem;
  }
  
  .team-item {
    max-width: 100%;
    min-width: auto;
    flex: none;
  }
  
  .timeline::before {
    left: 20px;
  }
  
  .timeline-item {
    flex-direction: row !important;
  }
  
  .timeline-date {
    flex: 0 0 80px;
    font-size: 0.9rem;
    padding: 0.5rem;
  }
  
  .timeline-content {
    margin-left: 1rem !important;
    margin-right: 0 !important;
  }
  
  .comparison-row {
    grid-template-columns: 1fr;
    gap: 0.5rem;
  }
  
  .comparison-cell {
    text-align: left !important;
    padding: 0.3rem;
  }
}
</style>
